module.exports = __webpack_public_path__ + "ba235bf7f92f6c8831dbba367fb9420d.fbx";